import React, { useCallback, useState } from 'react';
import DashboardImage from '../../resources/images/signup-dashboard.webp';
import { useDispatch } from 'react-redux';
import { signUpUser } from '../../../app/page/page-storage/users/users.actions';
import { IUserSignUpForm } from '../../../app/resource/user/user.types';
import { SignUpForm } from './SignUpForm';
import { Footer } from './Footer';
import GoogleSSOButton from '../common/sso-buttons/GoogleSSOButton';
import { Link } from 'react-router-dom';

export const SignUpPage = () => {
  const dispatch = useDispatch();
  const [userInfo, setUserInfo] = useState<
    { firstName: string; lastName: string; email: string; token: string } | undefined
  >(undefined);

  const handleSignUpFormSubmit = useCallback(
    (data: IUserSignUpForm) => {
      // signup the user / register the tenant
      dispatch(signUpUser({ ...data }));
    },
    [dispatch],
  );

  const populateForm = (data: any) => {
    const userInfo = {
      firstName: data.user.given_name,
      lastName: data.user.family_name,
      email: data.user.email,
      token: data.token,
    };
    setUserInfo(userInfo);
  };

  return (
    <main id="app-root" className="signup-page">
      <div className="signup-page__form-side">
        <div className="signup-page__form-inner">
          <div className="signup-page__logo" role="img" aria-label="account-able" />
          <h1 className="signup-page__title">Create your account</h1>
          <p className="signup-page__subtitle">Start running better meetings today.</p>

          <GoogleSSOButton onClick={populateForm} />
          <div className="signup-page__divider">or</div>

          <SignUpForm onSubmit={handleSignUpFormSubmit} userInfo={userInfo} />
          <Footer />

          <p className="signup-page__terms">
            By creating an account, you agree to the{' '}
            <a href="https://www.account-able.io/terms-of-service" target="_blank" rel="noopener noreferrer">
              Terms of Service
            </a>{' '}
            and{' '}
            <a href="https://www.account-able.io/privacy" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>
            .
          </p>

          <div className="signup-page__login-link">
            Already have an account? <Link to="/login">Log in</Link>
          </div>
        </div>
      </div>

      <div className="signup-page__visual-side" aria-hidden="true">
        <div className="signup-page__visual-content">
          <h2 className="signup-page__visual-title">Where Meetings Lead to Milestones</h2>
          <p className="signup-page__visual-text">
            Turn recurring meetings into structured, results-driven sessions—decisions, tasks, and progress in one
            place.
          </p>
          <img src={DashboardImage} alt="" className="signup-page__visual-image" />
        </div>
      </div>
    </main>
  );
};
